import { render, staticRenderFns } from "./prizeSetting.vue?vue&type=template&id=75345dfe"
import script from "./prizeSetting.vue?vue&type=script&lang=js"
export * from "./prizeSetting.vue?vue&type=script&lang=js"
import style0 from "./prizeSetting.vue?vue&type=style&index=0&id=75345dfe&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports